import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  box: {
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  default: {
    padding: theme.spacing(2),
  },
  wide: {
    padding: theme.spacing(2, 4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
    },
  },
  compact: {
    padding: theme.spacing(2),
  },
  noPadTop: {
    paddingTop: 0,
  },
  noPadBottom: {
    paddingBottom: 0,
  },
  noPadLeft: {
    paddingLeft: 0,
  },
  noPadRight: {
    paddingRight: 0,
  },
}))
